import { render } from "./DisplayWorks.vue?vue&type=template&id=de77b230&scoped=true"
import script from "./DisplayWorks.vue?vue&type=script&lang=js"
export * from "./DisplayWorks.vue?vue&type=script&lang=js"

import "./DisplayWorks.vue?vue&type=style&index=0&id=de77b230&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-de77b230"

export default script